import React from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';

function Heading({ level = 5, children, element }) {
    const levelMap = {
        1: {
            element: "h1",
            size: "jumbo",
            fontWeight: "black",
            textColor: "heading",
        },
        2: {
            element: "h2",
            size: "largest",
            fontWeight: "bold",
            textColor: "heading",
        },
        3: {
            element: "h3",
            size: "larger",
            fontWeight: "bold",
            textColor: "heading",
        },
        4: {
            element: "h4",
            size: "large",
            fontWeight: "bold",
            textColor: "heading",
        },
        5: {
            element: "h5",
            size: "base",
            fontWeight: "bold",
            textColor: "heading",
        },
        6: {
            element: "h6",
            size: "small",
            textCase: "uppercase",
            fontWeight: "bold",
            textColor: "heading",
        },
    };
    return (React.createElement(Typography, Object.assign({}, levelMap[level], { element: element || levelMap[level].element }), children));
}

export { Heading as H };
